import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { RecipeCreationPayload, IRecipe } from "../types/index";

export const recipeApi = createApi({
  reducerPath: "recipeApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getRecipes: builder.query<{ recipes: IRecipe[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/recipes/dashboard?${queryString}`;
      },
    }),
    getRecipeById: builder.query<IRecipe, string>({
      query: (recipeId) => `/recipes/${recipeId}`,
    }),
    sortIngredients: builder.mutation<void, { list: { id: string; recipeId: string; index: number }[] }>({
      query: (body) => ({
        url: "/recipes/ingredients/sort",
        method: "POST",
        body,
      }),
    }),
    createRecipe: builder.mutation<void, RecipeCreationPayload >({
      query: (body) => ({
        url: "/recipes",
        method: "POST",
        body,
      }),
    }),
    updateRecipe: builder.mutation<void, {id: string; body: RecipeCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/recipes/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateVisibalityInHome: builder.mutation<void, {id: string; activeInHome: boolean}>({
      query: ({ id, activeInHome }) => ({
        url: `/recipes/${id}/info`,
        method: "PATCH",
        body: { activeInHome },
      }),
    }),
    deleteRecipe: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/recipes/${id}`,
        method: "DELETE",
      }),
    }),
    deleteRecipeInfo: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/recipes/recipe-instruction/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetRecipesQuery,
  useLazyGetRecipesQuery,
  useDeleteRecipeMutation,
  useDeleteRecipeInfoMutation,
  useCreateRecipeMutation,
  useSortIngredientsMutation,
  useUpdateRecipeMutation,
  useLazyGetRecipeByIdQuery,
  useUpdateVisibalityInHomeMutation
} = recipeApi;
